module.exports = __webpack_public_path__ + "img/lvhua_bg.56ec0294.png";